import { render, staticRenderFns } from "./ModalBirthday.vue?vue&type=template&id=11996526"
import script from "./ModalBirthday.vue?vue&type=script&lang=js"
export * from "./ModalBirthday.vue?vue&type=script&lang=js"
import style0 from "./ModalBirthday.vue?vue&type=style&index=0&id=11996526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports